import PermissionRepository from "@common/domain/data/PermissionRepository";
import Permission from "@common/domain/entities/Permission";
import User from "@common/domain/entities/User";

export default class APIPermissionRepository implements PermissionRepository{
    savePermission(user: User, permission: Permission): Promise<Permission> {
        throw new Error("Method not implemented.");
    }
}